export const FIRST_NAME = "ARJUN";
export const LAST_NAME = "GURURAJAN";
export const DESIGNATION = "Senior Software Engineer (5.6 yrs)";
export const OBJECTIVE = "I am a problem solver and a fast learner with an ability to turnaround things quickly and effectively. I want to work in an environment where my skills can be utilized to the maximum as it will be beneficial to the organization and also will help me to grow."
export const ADDRESS = "Parappana Agrahara, Bangalore, Karnataka - 560100";
export const PHONE = "+91 7411731914";
export const EMAIL = "nag9209@gmail.com";
export const FACEBOOK = "https://www.facebook.com/arjun.gcj";
export const GITHUB = "https://github.com/arjun9218";
export const GITHUB_PORTFOLIO = "https://github.com/arjun9218/portfolio";
export const JOB_SKILL1 = "Owning a task end to end and driving it to completion either individually or along with a team.";
export const JOB_SKILL2 = "Gathering requirements, conducting requirements workshop, sprint planning, standup meetings and demo sessions. Basically following Agile practices.";
export const JOB_SKILL3 = "Knowledgeable in using the JIRA tool for managing backlogs, creating User stories & bugs, tracking the burndown charts and adding tests.";
export const JOB_SKILL4 = "Proficient in demonstrating the developed application features to customers and stakeholders.";
export const JOB_SKILL5 = "Experienced in using the GitHub from creating a repository, reviewing teammates' pull requests to adding hooks for automating builds using CI CD.";
export const JOB_SKILL6 = "Capable in adapting to work with any new cutting edge technology.";
export const TECHNOLOGY1 = "JavaScript";
export const TECHNOLOGY2 = "HTML/CSS";
export const TECHNOLOGY3 = "Java EE";
export const TECHNOLOGY4 = "Database";
export const TECHNOLOGY5 = "Deployment";
export const EXP_WITH1 = "React JS, Node JS, Angular JS, Karma and Cypress test framework.";
export const EXP_WITH2 = "HTML5, CSS in JS, Sass & SCSS.";
export const EXP_WITH3 = "Core Java, Spring boot, Hibernates and JUnit unit test framework.";
export const EXP_WITH4 = "Mongo DB and MySQL.";
export const EXP_WITH5 = "Docker, AWS Kubernetes and Openshift.";
export const SYNAMEDIA_URL = "https://www.synamedia.com/";
export const OPENTEXT_URL = "https://www.opentext.com/";
